import { getGeoPoint } from '../system/firebase';
import { ELASTICSEARCH_API_URL_PREFIX } from '../system/constants';
import {
    DISTANCE,
    PAY_FREQUENCY_LIST_BI_WEEKLY,
    PAY_FREQUENCY_LIST_DAILY,
    PAY_FREQUENCY_LIST_HOURLY,
    PAY_FREQUENCY_LIST_MONTHLY,
    PAY_FREQUENCY_LIST_PER_JOB,
    PAY_FREQUENCY_LIST_WEEKLY,
    PAY_FREQUENCY_LIST_YEARLY,
    SORT_OPTION_DATE,
    SORT_OPTION_RELEVANCE,
    TELEWORK_LIST_COMPLETE,
    TELEWORK_LIST_PARTIAL,
} from './constants';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _forEach from 'lodash/forEach';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import _toNumber from 'lodash/toNumber';
import { getTime, isValid as isValidDate } from 'date-fns';

export const ELASTICSEARCH_SYNC_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/collection/store`;
export const ELASTICSEARCH_SUGGESTION_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/autocomplete`;
export const ELASTICSEARCH_OCCUPATION_SKILL_SET_SUGGESTION_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/occupation/suggestion`;
export const ELASTICSEARCH_JOB_TITLE_SKILL_SET_SUGGESTION_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/job/suggestion`;
export const ELASTICSEARCH_LOCATION_SUGGESTION_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/location/autocomplete`;
export const ELASTICSEARCH_JS_NAME_OCCUPATION_SUGGESTION_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/js-profile/occupation/autocomplete`;
export const ELASTICSEARCH_SEARCH_JOB_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/job`;
export const ELASTICSEARCH_SEARCH_JS_PROFILE_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/js-profile`;
export const ELASTICSEARCH_SEARCH_EMP_PROFILE_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/emp-profile`;
export const ELASTICSEARCH_SEARCH_JS_SAVED_JOB_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/js-saved-job`;
export const ELASTICSEARCH_SEARCH_JS_APPLIED_JOB_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/js-applied-job`;
export const ELASTICSEARCH_SEARCH_EMP_JOB_API_URL = `${ELASTICSEARCH_API_URL_PREFIX}/search/emp-job`;

export const ELASTICSEARCH_JWT_MAX_AGE = 10; // minutes
export const ELASTICSEARCH_PAGE_SIZE = 10;

export const ELASTICSEARCH_TYPE_JOB = 'JOB';
export const ELASTICSEARCH_TYPE_CITY = 'CITY';
export const ELASTICSEARCH_TYPE_STATE = 'STATE';
export const ELASTICSEARCH_TYPE_COUNTRY = 'COUNTRY';
export const ELASTICSEARCH_TYPE_LOCATION = 'LOCATION';
export const ELASTICSEARCH_TYPE_INDUSTRY = 'INDUSTRY';
export const ELASTICSEARCH_TYPE_OCCUPATION = 'OCCUPATION';
export const ELASTICSEARCH_TYPE_OTHER_EDUCATION = 'OTHER_EDUCATION';
export const ELASTICSEARCH_TYPE_SKILL_SET = 'SKILL_SET';
export const ELASTICSEARCH_TYPE_EMP_JOB = 'EMP_JOB';
export const ELASTICSEARCH_TYPE_JS_APPLIED_JOB = 'JS_APPLIED_JOB';
export const ELASTICSEARCH_TYPE_JS_SAVED_JOB = 'JS_SAVED_JOB';
export const ELASTICSEARCH_TYPE_JS_PROFILE = 'JS_PROFILE';
export const ELASTICSEARCH_TYPE_EMP_PROFILE = 'EMP_PROFILE';
export const ELASTICSEARCH_TYPE_THREAD_SUMMARY = 'THREAD_SUMMARY';

export const ELASTICSEARCH_SORT_COLUMN_CREATE_DATE = 'CREATE_DATE';
export const ELASTICSEARCH_SORT_COLUMN_ACTIVE_DATE = 'ACTIVE_DATE';
export const ELASTICSEARCH_SORT_COLUMN_STATUS_DATE = 'STATUS_DATE';
export const ELASTICSEARCH_SORT_COLUMN_UPDATE_DATE = 'UPDATE_DATE';
export const ELASTICSEARCH_SORT_COLUMN_APPLY_DATE = 'APPLY_DATE';
export const ELASTICSEARCH_SORT_COLUMN_DISTANCE = 'DISTANCE';
export const ELASTICSEARCH_SORT_ORDER_ASC = 'ASC';
export const ELASTICSEARCH_SORT_ORDER_DESC = 'DESC';

export const ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT = 'ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT';
export const ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_DESC = 'ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_DESC';
export const ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_ASC = 'ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_ASC';
export const ELASTICSEARCH_SORT_OPTION_STATUS_DATE_DESC = 'ELASTICSEARCH_SORT_OPTION_STATUS_DATE_DESC';
export const ELASTICSEARCH_SORT_OPTION_STATUS_DATE_ASC = 'ELASTICSEARCH_SORT_OPTION_STATUS_DATE_ASC';
export const ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC = 'ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC';
export const ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_ASC = 'ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_ASC';
export const ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC = 'ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC';
export const ELASTICSEARCH_SORT_OPTION_APPLY_DATE_ASC = 'ELASTICSEARCH_SORT_OPTION_APPLY_DATE_ASC';
export const ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC = 'ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC';

export const ELASTICSEARCH_SORT_OPTIONS = {
    ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT: {},
    ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_DESC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_ACTIVE_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_DESC },
    ELASTICSEARCH_SORT_OPTION_ACTIVE_DATE_ASC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_ACTIVE_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_ASC },
    ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_UPDATE_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_DESC },
    ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_ASC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_UPDATE_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_ASC },
    ELASTICSEARCH_SORT_OPTION_APPLY_DATE_DESC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_APPLY_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_DESC },
    ELASTICSEARCH_SORT_OPTION_APPLY_DATE_ASC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_APPLY_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_ASC },
    ELASTICSEARCH_SORT_OPTION_STATUS_DATE_DESC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_STATUS_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_DESC },
    ELASTICSEARCH_SORT_OPTION_STATUS_DATE_ASC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_STATUS_DATE, sortOrder: ELASTICSEARCH_SORT_ORDER_ASC },
    ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC: { sortColumn: ELASTICSEARCH_SORT_COLUMN_DISTANCE, sortOrder: ELASTICSEARCH_SORT_ORDER_ASC },
};

export const SEARCH_PUBLIC_INITIAL_SORT_OPTIONS = [{ value: ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC, label: SORT_OPTION_DATE }];

export const LAT_LONG_ONLY_SEARCH_SORT_OPTIONS = [
    { value: ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC, label: SORT_OPTION_DATE },
    { value: ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC, label: DISTANCE },
];

export const SEARCH_WITH_LAT_LONG_SORT_OPTIONS = [
    { value: ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT, label: SORT_OPTION_RELEVANCE },
    { value: ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC, label: SORT_OPTION_DATE },
    { value: ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC, label: DISTANCE },
];

export const SEARCH_WITHOUT_LAT_LONG_SORT_OPTIONS = [
    { value: ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT, label: SORT_OPTION_RELEVANCE },
    { value: ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC, label: SORT_OPTION_DATE },
];

//-----------------------------------------------------------------------------
// Utilities
//-----------------------------------------------------------------------------
export const getLocationQueryObject = ({ location } = {}) => {
    let locationQueryObject = {};

    const locationType = _get(location, 'type');
    switch (locationType) {
        case ELASTICSEARCH_TYPE_COUNTRY: {
            locationQueryObject = {
                country: _get(location, 'name'),
            };
            break;
        }
        case ELASTICSEARCH_TYPE_STATE: {
            locationQueryObject = {
                country: _get(location, 'country'),
                state: _get(location, 'name'),
            };
            break;
        }
        case ELASTICSEARCH_TYPE_CITY: {
            const cityLocationLatitude = _get(location, 'location.lat');
            const cityLocationLongitude = _get(location, 'location.lon');
            if (cityLocationLatitude && cityLocationLongitude) {
                _set(locationQueryObject, 'location', _get(location, 'location'));
            } else {
                // if no lat/long, match city name
                _set(locationQueryObject, 'city', _get(location, 'name'));
                _set(locationQueryObject, 'state', _get(location, 'state'));
                _set(locationQueryObject, 'country', _get(location, 'country'));
            }
            break;
        }
        default:
        // do nothing
    }

    return locationQueryObject;
};

//-----------------------------------------------------------------------------
// Map single fields
//-----------------------------------------------------------------------------
export const mapDateToElasticSearchTimestamp = dt => {
    return isValidDate(dt) ? null : getTime(dt);
};

//-----------------------------------------------------------------------------
// Map fields in data (object)
//-----------------------------------------------------------------------------
// timestamp (ms)
export const mapToElasticSearchTimestamp = (data, timestampFieldNameList) => {
    _forEach(timestampFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            _set(data, fieldName, isValidDate(field.toDate()) ? getTime(field.toDate()) : null);
        }
    });
    return data;
};
export const mapFromElasticSearchTimestamp = (data, timestampFieldNameList) => {
    _forEach(timestampFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            _set(data, fieldName, isValidDate(field) ? new Date(field) : null);
        }
    });
    return data;
};

// location (lat/lon)
export const mapToElasticSearchLocation = (data, locationFieldNameList) => {
    _forEach(locationFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            const latitude = _get(field, 'latitude', null);
            const longitude = _get(field, 'longitude', null);
            _set(data, fieldName, !latitude || !longitude ? null : { lat: latitude, lon: longitude });
        }
    });
    return data;
};
export const mapFromElasticSearchLocation = (data, locationFieldNameList) => {
    _forEach(locationFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            const latitude = _get(field, 'lat', null);
            const longitude = _get(field, 'lon', null);
            _set(data, fieldName, !latitude || !longitude ? null : getGeoPoint(_toNumber(latitude), _toNumber(longitude)));
        }
    });
    return data;
};

//=============================================================================
// Map data (object) from specific collection
//=============================================================================
//-----------------------------------------------------------------------------
// Map jobs document
//-----------------------------------------------------------------------------
const pickJobsFields = data => {
    return _pick(data, [
        'active',
        'activeDt',
        'benefitSummary',
        'city',
        'cityLocation',
        'comingSoon',
        'companyBio',
        'companyName',
        'companyProfilePicUrl',
        'country',
        'createDt',
        'currency',
        'currencySymbol',
        'education',
        'employerId',
        'employmentType',
        'filled',
        'hired',
        'inactiveDt',
        'intern',
        'isEmpBadge',
        'isExactRate',
        'jobApplicationUrl',
        'jobDescription',
        'jobTitle',
        'otherEducation',
        'payFrequency',
        'rateMax',
        'rateMin',
        'reqNum',
        'state',
        'statusDt',
        'telework',
        'updateDt',
        'yrsOfExp',
    ]);
};
export const mapJobsDataToElasticSearchJson = (data = {}, id) => {
    const pickedData = pickJobsFields(data);
    const { rateMin, rateMax, payFrequency, telework, createDt, updateDt } = pickedData;

    // derive rateYearlyMin, rateYearlyMax, rateDailyMin, rateDailyMax
    let salaryRateEsDto = {};
    let rateYearlyMin = null;
    let rateYearlyMax = null;
    let rateDailyMin = null;
    let rateDailyMax = null;
    let ratePerJobMin = null;
    let ratePerJobMax = null;
    switch (payFrequency) {
        case PAY_FREQUENCY_LIST_HOURLY: {
            rateYearlyMin = rateMin * 2080;
            rateYearlyMax = rateMax * 2080;
            break;
        }
        case PAY_FREQUENCY_LIST_DAILY: {
            rateDailyMin = rateMin;
            rateDailyMax = rateMax;
            break;
        }
        case PAY_FREQUENCY_LIST_WEEKLY: {
            rateYearlyMin = rateMin * 52;
            rateYearlyMax = rateMax * 52;
            break;
        }
        case PAY_FREQUENCY_LIST_MONTHLY: {
            rateYearlyMin = rateMin * 12;
            rateYearlyMax = rateMax * 12;
            break;
        }
        case PAY_FREQUENCY_LIST_YEARLY: {
            rateYearlyMin = rateMin;
            rateYearlyMax = rateMax;
            break;
        }
        case PAY_FREQUENCY_LIST_PER_JOB: {
            ratePerJobMin = rateMin;
            ratePerJobMax = rateMax;
            break;
        }
        default:
        // do nothing
    }
    salaryRateEsDto = { rateYearlyMax, rateYearlyMin, rateDailyMax, rateDailyMin, ratePerJobMin, ratePerJobMax };

    // derive isTelework
    let isTeleworkEsDto = {};
    switch (telework) {
        case TELEWORK_LIST_COMPLETE:
        case TELEWORK_LIST_PARTIAL: {
            isTeleworkEsDto = { isTelework: true };
            break;
        }
        default:
            isTeleworkEsDto = { isTelework: false };
    }

    // for ElasticSearch, if updateDt is nil, set it to createDt (for sort)
    if (!updateDt) _set(pickedData, 'updateDt', createDt);

    return {
        id,
        ...mapToElasticSearchLocation(mapToElasticSearchTimestamp(pickedData, ['activeDt', 'createDt', 'inactiveDt', 'statusDt', 'updateDt']), ['cityLocation']),
        ...salaryRateEsDto,
        ...isTeleworkEsDto,
    };
};
export const mapJobsDataFromElasticSearchJson = (data = {}) => {
    const id = _get(data, 'id');
    return _omit(
        {
            uid: id,
            ...mapFromElasticSearchLocation(mapFromElasticSearchTimestamp(data, ['activeDt', 'createDt', 'inactiveDt', 'statusDt', 'updateDt']), ['cityLocation']),
        },
        ['id'],
    );
};

//-----------------------------------------------------------------------------
// Map profilesEmp document
//-----------------------------------------------------------------------------
const pickProfilesEmpFields = data => {
    const pickedBrand = _pick(_get(data, 'brand'), ['bannerUrl', 'profilePicUrl']);
    const pickedInfo = _pick(_get(data, 'info'), [
        'benefit',
        'bio',
        'companyName',
        'companySize',
        'city',
        'cityLocation',
        'country',
        'foundedYr',
        'industry',
        'isEmpBadge',
        'state',
    ]);
    const pickedSocial = _pick(_get(data, 'social'), ['facebookUrl', 'gitHubUrl', 'instagramUrl', 'linkedInUrl', 'tikTokUrl', 'twitterUrl', 'websiteUrl', 'youTubeUrl']);
    return {
        ..._pick(data, ['activeJobsCount', 'createDt', 'isPublic', 'updateDt']),
        brand: pickedBrand,
        info: mapToElasticSearchLocation(pickedInfo, ['cityLocation']),
        social: pickedSocial,
    };
};
export const mapProfilesEmpDataToElasticSearchJson = (data = {}, id) => {
    const pickedData = pickProfilesEmpFields(data);
    return {
        id,
        ...mapToElasticSearchTimestamp(pickedData, ['createDt', 'updateDt']),
    };
};
export const mapProfilesEmpDataFromElasticSearchJson = (data = {}) => {
    const id = _get(data, 'id');
    const info = _get(data, 'info');
    return _omit(
        {
            employerId: id,
            ...mapFromElasticSearchTimestamp(data, ['createDt', 'updateDt']),
            info: mapFromElasticSearchLocation(info, ['cityLocation']),
        },
        ['id'],
    );
};

//-----------------------------------------------------------------------------
// Map profiles document
//-----------------------------------------------------------------------------
const pickProfilesFields = data => {
    const pickedResumeList = _map(_get(data, 'resumeList'), resume => {
        const pickedAttachment = _pick(_get(resume, 'attachment'), ['key', 'url', 'title', 'type', 'size']);
        return { ..._pick(resume, ['isActive', 'title', 'updateDt']), attachment: pickedAttachment };
    });
    const pickedVideo = _map(_get(data, 'video'), vid => {
        return _pick(vid, ['videoId']);
    });
    return {
        ..._pick(data, [
            'aboutMe',
            'city',
            'cityLocation',
            'country',
            'createDt',
            'currency',
            'currencySymbol',
            'facebookUrl',
            'education',
            'employmentType',
            'firstName',
            'gender',
            'gitHubUrl',
            'instagramUrl',
            'isExactRate',
            'isPublic',
            'lastName',
            'linkedInUrl',
            'middleName',
            'occupation',
            'otherEducation',
            'payFrequency',
            'profilePicUrl',
            'race',
            'rateMax',
            'rateMin',
            'skillset',
            'state',
            'tikTokUrl',
            'twitterUrl',
            'updateDt',
            'uploadedVideoId',
            'uploadedVideoStatus',
            'videoOverviewDuration',
            'videoOverviewKey',
            'videoOverviewName',
            'videoOverviewSize',
            'videoOverviewType',
            'videoOverviewUrl',
            'websiteUrl',
            'willingRelocate',
            'yearsOfExperience',
            'youTubeUrl',
        ]),
        resumeList: pickedResumeList,
        video: pickedVideo,
    };
};
export const mapProfilesDataToElasticSearchJson = (data = {}, id) => {
    const pickedData = pickProfilesFields(data);
    const { rateMin, rateMax, payFrequency } = pickedData;

    // derive rateYearlyMin, rateYearlyMax, rateDailyMin, rateDailyMax
    let salaryRateEsDto = {};
    let rateYearlyMin = null;
    let rateYearlyMax = null;
    let rateDailyMin = null;
    let rateDailyMax = null;
    let ratePerJobMin = null;
    let ratePerJobMax = null;
    switch (payFrequency) {
        case PAY_FREQUENCY_LIST_HOURLY: {
            rateYearlyMin = rateMin * 2080;
            rateYearlyMax = rateMax * 2080;
            break;
        }
        case PAY_FREQUENCY_LIST_DAILY: {
            rateDailyMin = rateMin;
            rateDailyMax = rateMax;
            break;
        }
        case PAY_FREQUENCY_LIST_WEEKLY: {
            rateYearlyMin = rateMin * 52;
            rateYearlyMax = rateMax * 52;
            break;
        }
        case PAY_FREQUENCY_LIST_BI_WEEKLY: {
            rateYearlyMin = rateMin * 26;
            rateYearlyMax = rateMax * 26;
            break;
        }
        case PAY_FREQUENCY_LIST_MONTHLY: {
            rateYearlyMin = rateMin * 12;
            rateYearlyMax = rateMax * 12;
            break;
        }
        case PAY_FREQUENCY_LIST_YEARLY: {
            rateYearlyMin = rateMin;
            rateYearlyMax = rateMax;
            break;
        }
        case PAY_FREQUENCY_LIST_PER_JOB: {
            ratePerJobMin = rateMin;
            ratePerJobMax = rateMax;
            break;
        }
        default:
        // do nothing
    }
    salaryRateEsDto = { rateYearlyMax, rateYearlyMin, rateDailyMax, rateDailyMin, ratePerJobMin, ratePerJobMax };

    const resumeList = _get(pickedData, 'resumeList', []);
    const mappedResumeList = _map(resumeList, resume => {
        return mapToElasticSearchTimestamp(resume, ['updateDt']);
    });
    return {
        id,
        ...mapToElasticSearchLocation(mapToElasticSearchTimestamp(pickedData, ['createDt', 'updateDt']), ['cityLocation']),
        resumeList: mappedResumeList,
        ...salaryRateEsDto,
    };
};
export const mapProfilesDataFromElasticSearchJson = (data = {}) => {
    const id = _get(data, 'id');
    const resumeList = _get(data, 'resumeList', []);
    const mappedResumeList = _map(resumeList, resume => {
        return mapFromElasticSearchTimestamp(resume, ['updateDt']);
    });
    return _omit(
        {
            uid: id,
            ...mapFromElasticSearchLocation(mapFromElasticSearchTimestamp(data, ['createDt', 'updateDt']), ['cityLocation']),
            resumeList: mappedResumeList,
        },
        ['id'],
    );
};

//-----------------------------------------------------------------------------
// Map threadMessages document
//-----------------------------------------------------------------------------
const pickThreadMessagesFields = data => {
    const pickedAttachment = _pick(_get(data, 'attachment'), ['url', 'title', 'type', 'size']);
    return {
        ..._pick(data, ['content', 'createDt', 'jobId', 'jobSeekerId', 'senderId', 'threadId']),
        attachment: pickedAttachment,
    };
};
export const mapThreadMessagesDataToElasticSearchJson = (data = {}, id) => {
    const pickedData = pickThreadMessagesFields(data);
    return {
        id,
        ...mapToElasticSearchTimestamp(pickedData, ['createDt']),
    };
};

//-----------------------------------------------------------------------------
// Map empJobs document
//-----------------------------------------------------------------------------
const pickEmpJobsFields = data => {
    const jobSeekers = _get(data, 'jobSeekers');
    const jobSeekerIdList = _keys(jobSeekers);
    const pickedJobSeekers = [];
    _forEach(jobSeekerIdList, jobSeekerId => {
        _set(
            pickedJobSeekers,
            `[${jobSeekerId}]`,
            _pick(jobSeekers[jobSeekerId], ['applyDt', 'accountDeleteDt', 'email', 'firstName', 'lastName', 'profilePicUrl', 'savedDt', 'userId']),
        );
    });
    return {
        ..._pick(data, [
            'active',
            'activeDt',
            'applicants',
            'city',
            'cityLocation',
            'comingSoon',
            'companyName',
            'companyProfilePicUrl',
            'country',
            'createDt',
            'currency',
            'currencySymbol',
            'education',
            'employmentType',
            'filled',
            'inactiveDt',
            'intern',
            'isEmpBadge',
            'isExactRate',
            'jobApplicationUrl',
            'jobDescription',
            'jobTitle',
            'jsEngageCount',
            'otherEducation',
            'payFrequency',
            'rateMax',
            'rateMin',
            'reqNum',
            'savedJs',
            'state',
            'statusDt',
            'telework',
            'updateDt',
            'yrsOfExp,',
        ]),
        jobSeekers: pickedJobSeekers,
    };
};
export const mapEmpJobsDataToElasticSearchJson = (data = {}, jobId, esId, parentId) => {
    const pickedData = pickEmpJobsFields(data);

    const jobSeekers = _get(pickedData, 'jobSeekers');
    const jobSeekerIdList = _keys(jobSeekers);
    const mappedJobSeekers = _map(jobSeekerIdList, jobSeekerId => {
        const jobSeekerData = { ...jobSeekers[jobSeekerId], userId: jobSeekerId };
        return mapToElasticSearchTimestamp(jobSeekerData, ['applyDt', 'savedDt']);
    });
    // const temp = _get(pickedData, 'createDt');
    // const tempDt = temp ? temp.toDate() : new Date();
    return {
        id: esId,
        parentId,
        ...mapToElasticSearchLocation(mapToElasticSearchTimestamp(pickedData, ['activeDt', 'inactiveDt', 'createDt', 'statusDt', 'updateDt']), ['cityLocation']),
        jobSeekers: mappedJobSeekers,
        uid: jobId,
        // updateDt: tempDt,
    };
};
export const mapEmpJobsDataFromElasticSearchJson = (data = {}) => {
    // const id = _get(data, 'id');

    const jobSeekers = _get(data, 'jobSeekers');
    const mappedJobSeekers = {};
    _forEach(jobSeekers, item => {
        _set(mappedJobSeekers, item.userId, item);
    });

    return _omit(
        {
            ...mapFromElasticSearchLocation(mapFromElasticSearchTimestamp(data, ['activeDt', 'inactiveDt', 'createDt', 'statusDt', 'updateDt']), ['cityLocation']),
            jobSeekers: mappedJobSeekers,
        },
        ['id'],
    );
};

//-----------------------------------------------------------------------------
// Map threadSummaries document
//-----------------------------------------------------------------------------
const pickThreadSummariesFields = data => {
    return _pick(data, [
        'active',
        'companyName',
        'companyProfilePicUrl',
        'deleteDt',
        'employerId',
        'followUpDt',
        'isEmpBadge',
        'jobId',
        'jobSeekerId',
        'jobSeekerName',
        'jobSeekerProfilePicUrl',
        'jobTitle',
        'lastMessage',
        'lastMessageDt',
        'lastReadDt',
        'unreadCount',
    ]);
};
export const mapThreadSummariesDataToElasticSearchJson = (data = {}, esId, parentId) => {
    const pickedData = pickThreadSummariesFields(data);

    // determine if this document belongs to a job seeker (only JS has employerId)
    const employerId = _get(pickedData, 'employerId');
    const isJs = !!employerId;

    // convert followUpDt map to array
    const followUpDts = _get(pickedData, 'followUpDt');
    const userOrEmpIdList = _keys(followUpDts);
    const mappedFollowUpDtList = _map(userOrEmpIdList, userOrEmpId => {
        return mapToElasticSearchTimestamp({ followUpDt: _get(followUpDts, `${userOrEmpId}`), userId: isJs ? userOrEmpId : null, employerId: isJs ? null : userOrEmpId }, [
            'followUpDt',
        ]);
    });

    return {
        id: esId,
        parentId,
        ...mapToElasticSearchTimestamp(pickedData, ['deleteDt', 'lastMessageDt', 'lastReadDt']),
        followUpDtList: mappedFollowUpDtList,
    };
};

//-----------------------------------------------------------------------------
// Map jsAppliedJobs (appliedJobs) document
//-----------------------------------------------------------------------------
const pickJsAppliedJobsFields = data => {
    return _pick(data, [
        'active',
        'activeDt',
        'applyDt',
        'city',
        'cityLocation',
        'comingSoon',
        'country',
        'createDt',
        'currency',
        'currencySymbol',
        'deleteDt',
        'education',
        'employerId',
        'employmentType',
        'filled',
        'inactiveDt',
        'intern',
        'isExactRate',
        'jobApplicationUrl',
        'jobDescription',
        'jobTitle',
        'note',
        'otherEducation',
        'parentId',
        'payFrequency',
        'rateMax',
        'rateMin',
        'state',
        'statusDt',
        'telework',
        'yrsOfExp',
        'uid',
        'updateDt',
    ]);
};
export const mapJsAppliedJobsDataToElasticSearchJson = (data = {}, esId, parentId) => {
    const pickedData = pickJsAppliedJobsFields(data);
    return {
        id: esId,
        parentId,
        ...mapToElasticSearchLocation(mapToElasticSearchTimestamp(pickedData, ['activeDt', 'inactiveDt', 'applyDt', 'createDt', 'deleteDt', 'statusDt', 'updateDt']), [
            'cityLocation',
        ]),
    };
};
export const mapJsAppliedJobsDataFromElasticSearchJson = (data = {}) => {
    // const id = _get(data, 'id');
    return _omit(
        {
            ...mapFromElasticSearchLocation(mapFromElasticSearchTimestamp(data, ['activeDt', 'inactiveDt', 'applyDt', 'createDt', 'deleteDt', 'statusDt', 'updateDt']), [
                'cityLocation',
            ]),
        },
        ['id'],
    );
};

//-----------------------------------------------------------------------------
// Map jsSavedJobs document
//-----------------------------------------------------------------------------
const pickJsSavedJobsFields = data => {
    return _pick(data, [
        'active',
        'activeDt',
        'applyDt',
        'city',
        'cityLocation',
        'comingSoon',
        'country',
        'createDt',
        'currency',
        'currencySymbol',
        'deleteDt',
        'education',
        'employerId',
        'employmentType',
        'filled',
        'inactiveDt',
        'intern',
        'isExactRate',
        'jobApplicationUrl',
        'jobDescription',
        'jobTitle',
        'note',
        'otherEducation',
        'parentId',
        'payFrequency',
        'rateMax',
        'rateMin',
        'state',
        'statusDt',
        'telework',
        'yrsOfExp',
        'uid',
        'updateDt',
    ]);
};
export const mapJsSavedJobsDataToElasticSearchJson = (data = {}, esId, parentId) => {
    const pickedData = pickJsSavedJobsFields(data);
    return {
        id: esId,
        parentId,
        ...mapToElasticSearchLocation(mapToElasticSearchTimestamp(pickedData, ['activeDt', 'inactiveDt', 'applyDt', 'createDt', 'deleteDt', 'statusDt', 'updateDt']), [
            'cityLocation',
        ]),
    };
};
export const mapJsSavedJobsDataFromElasticSearchJson = (data = {}) => {
    // const id = _get(data, 'id');
    return _omit(
        {
            ...mapFromElasticSearchLocation(mapFromElasticSearchTimestamp(data, ['activeDt', 'inactiveDt', 'applyDt', 'createDt', 'deleteDt', 'statusDt', 'updateDt']), [
                'cityLocation',
            ]),
        },
        ['id'],
    );
};
